import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MaterialModule } from '@app/material.module';

@Component({
  selector: 'app-mathew-anderson',
  imports: [MaterialModule, MatBadgeModule],
  templateUrl: './mathew-anderson.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMathewAndersonComponent {}
